export default "__VITE_ASSET__DagcxJ6b__"